import {Dots} from "../../Shapes/Dots/Dots";
import {Shape1} from "../../Shapes/Section3/Shape1";
import {Shape2} from "../../Shapes/Section3/Shape2";
import sampleImage3 from "../../../../public/static/photojoiner.com-photo-stitch-sample-3.webp";
import Image from "next/image";
import {isMobile} from "react-device-detect";

export interface IStitchFeatureSection3Props {
  backgroundColor: string;
  imageSrc: string;
  shape1Color?: string;
  shape2Color?: string;
  dots1Color?: string;
  dots2Color?: string;
}

export const StitchFeatureSection3 = ({
  backgroundColor,
  imageSrc,
  shape1Color = "transparent",
  shape2Color = "transparent",
  dots1Color = "transparent",
  dots2Color = "transparent",
}: IStitchFeatureSection3Props) => {
  return (
    <div className="py-16 lg:py-36 px-4 xl:px-52" style={{ backgroundColor }}>
      <div className="flex flex-col lg:flex-row justify-center gap-8">
        <div className="w-full flex flex-col items-center justify-center gap-4 lg:px-4">
          <div className="flex flex-col gap-4 ">
            <h2 className="text-5xl lg:text-6xl" style={{ maxWidth: "16ch" }}>
              Merge Images Without Cropping
            </h2>

            <div className="leading-relaxed" style={{ maxWidth: "45ch" }}>
              Want to combine photos of different sizes without cropping them?
              You’ve found the right tool. You can customize the canvas size so
              that all your photos fit perfectly. Additionally, you can zoom in
              on your photos to highlight your subjects.
            </div>
            {/* <div><StitchPicturesButton/></div> */}
          </div>
        </div>
        <div className="w-full flex justify-center items-center lg:justify-start ">
          <div className="relative  w-full aspect-[1.18]">
            {/* <img src={imageSrc} className="opacity-0" alt="Photo stitch tool by PhotoJoiner"/> */}
            <Image
              src={sampleImage3}
              className="absolute inset-0 z-10"
              alt="Photo stitch tool by PhotoJoiner"
              width={isMobile ? 500 : 1000}
              sizes={`max-width: ${isMobile?500:1000}px`}
            />

            <div className="hidden lg:block absolute left-0 top-0 -translate-x-1/4 -translate-y-1/4">
              <Shape1 fill={shape1Color} />
            </div>

            <div className="hidden lg:block absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2">
              <Shape2 fill={shape2Color} />
            </div>

            <div className="hidden lg:block absolute right-1/2 top-0 -translate-y-1/4 translate-x-full">
              <Dots fill={dots1Color} />
            </div>

            <div className="hidden lg:block absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4">
              <Dots fill={dots2Color} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
